// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product p,.product ul{margin:0}.product h3,.product h4{margin:1.33em 0 0 0}.product a{color:#4c68cb}", "",{"version":3,"sources":["webpack://pages/Product/index.scss"],"names":[],"mappings":"AAAA,uBAEE,QAAA,CAGF,wBAEE,mBAAA,CAGF,WACE,aAAA","sourcesContent":[".product p,\n.product ul {\n  margin: 0;\n}\n\n.product h3,\n.product h4 {\n  margin: 1.33em 0 0 0;\n}\n\n.product a {\n  color: #4C68CB;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
